import {UserCountry} from "data/enums";

export const AVAIlABLE_ODDS_COUNTRIES = [UserCountry.CA, UserCountry.US];
